'use client';

import { useEffect, useRef } from 'react';
import { MODAL_TYPES, useModal } from '../../components/modal/ModalProvider';

export default function PriceDetails({
  title,
  children,
  isOpen,
  onClose,
  content
}) {
  const modalRef = useRef(null);
  const { modalUtils, getCloseButton } = useModal();

  useEffect(() => {
    if (isOpen && modalRef.current) {
      modalRef.current.focus({ preventScroll: true });
    }
  }, [isOpen]);

  return modalUtils.createModalWrapper({
    modalType: MODAL_TYPES.priceDetails,
    isOpen,
    onClose,
    containerClassName: modalUtils.containerPresets.standard.basic,
    children: (
      <div ref={modalRef} tabIndex={-1} className="modal-body body-r">
        {getCloseButton(MODAL_TYPES.priceDetails, onClose)}
        {title && <h2 className="sh10 pb-4 text-black">{title}</h2>}

        <div className="rte-simple text-black">
          {content ? (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  typeof content === 'string'
                    ? content
                    : content?.modal_body || ''
              }}
            />
          ) : (
            children
          )}
        </div>
      </div>
    )
  });
}
